import { FC } from 'react';

import { Typography } from '@mui/material';

import { ContentWrapper } from 'components/_basic/ContentWrapper/ContentWrapper';

import styles from './SectionTitle.module.scss';

interface IProps {
  title: string;
}

export const SectionTitle: FC<IProps> = ({ title }) => (
  <ContentWrapper className={styles.titleWrapper}>
    <Typography variant="h1" sx={{ fontSize: '28px', fontWeight: '700' }}>
      {title}
    </Typography>
  </ContentWrapper>
);
